// API Configuration
export const API_BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL || "http://localhost:3001";

// University Configuration
export const UNIVERSITY_CONFIG = {
  name: "University of British Columbia",
  shortName: "UBC",
  number: "1413",
};

// Department mapping for RateMyProfessors department numbers
// These numbers correspond to UBC departments on RateMyProfessors
export const DEPARTMENT_MAPPINGS = new Map([
  ["Accounting", 1],
  ["Administration", 248],
  ["Agriculture", 2],
  ["Anatomy", 678],
  ["Anthropology", 3],
  ["Architecture", 4],
  ["Art", 113],
  ["Art History", 5],
  ["Asian Studies", 177],
  ["Astronomy", 79],
  ["Audiology", 1149],
  ["Biochemistry & Molecular Biology", 1249],
  ["Biochemistry", 93],
  ["Biological Sciences", 189],
  ["Biology", 6],
  ["Botany", 206],
  ["Business", 7],
  ["Chemical & Biological Engineering", 2229],
  ["Chemistry", 8],
  ["Chinese", 68],
  ["Civil Engineering", 62],
  ["Classical & Medieval Studies", 674],
  ["Classical Studies", 1457],
  ["Classics", 9],
  ["Cognitive Systems", 2540],
  ["Communication", 10],
  ["Computer Engineering", 95],
  ["Computer Science", 11],
  ["Continuing Education", 1105],
  ["Counselling Psychology", 585],
  ["Creative Writing", 215],
  ["Curriculum & Instruction", 98],
  ["Dentistry", 1008],
  ["Earth Science", 78],
  ["Economics", 15],
  ["Education", 16],
  ["Education Psychology", 589],
  ["Educational Studies", 2384],
  ["Electrical & Computer Engineering", 1738],
  ["Electrical Engineering", 107],
  ["Engineering", 17],
  ["English", 18],
  ["English & Art", 3053],
  ["Environmental Studies", 264],
  ["Ethnic Studies", 19],
  ["European Studies", 702],
  ["Family Practice", 1348],
  ["Family Studies", 1033],
  ["Film", 20],
  ["Finance", 21],
  ["Fine Arts", 22],
  ["First Nations Studies", 1411],
  ["Fisheries Biology", 661],
  ["Food & Resource Economics", 2672],
  ["Food Science", 111],
  ["Foods & Nutrition", 984],
  ["Forestry", 73],
  ["French", 70],
  ["French, Hispanic, & Italian Studies", 1677],
  ["French, Italian, & Spanish Studies", 1974],
  ["Gastroenterology", 1358],
  ["Gender Studies", 1076],
  ["Gender, Race, Sexuality, & Social Justice", 2800],
  ["Geography", 23],
  ["Geology", 24],
  ["German", 65],
  ["Health & Human Services", 572],
  ["Health Science", 26],
  ["Health Services Management", 1305],
  ["Hispanic Studies", 1150],
  ["History", 27],
  ["Human Kinetics", 1199],
  ["Immigration Law", 1193],
  ["Information Science", 30],
  ["Information Systems", 246],
  ["Institute of Gender, Race, Sexuality, & Social Justice", 2995],
  ["Interdisciplinary Studies", 332],
  ["Italian", 81],
  ["Italian Studies", 1151],
  ["Japanese", 170],
  ["Journalism", 32],
  ["Kinesiology", 333],
  ["Land & Food Systems", 2423],
  ["Landscape Architecture & Regional Planning", 124],
  ["Language & Reading", 1395],
  ["Languages", 33],
  ["Law", 34],
  ["Library Science", 194],
  ["Linguistics", 129],
  ["Literature", 35],
  ["Logistics", 130],
  ["Managerial Science", 620],
  ["Marketing", 37],
  ["Materials Engineering", 289],
  ["Mathematics", 38],
  ["Mechanical Engineering", 69],
  ["Medical Genetics", 2634],
  ["Medicine", 39],
  ["Microbiology", 134],
  ["Modern Languages", 465],
  ["Music", 40],
  ["Near Eastern Studies", 342],
  ["Neurological Sciences", 1365],
  ["Neuroscience", 1302],
  ["Nursing", 41],
  ["Nutrition & Foods", 1005],
  ["Oceanography", 473],
  ["Operations Management", 621],
  ["Pathology", 1369],
  ["Pharmacy", 83],
  ["Philosophy", 42],
  ["Physical Education", 43],
  ["Physics", 44],
  ["Physics & Astronomy", 258],
  ["Physiology", 772],
  ["Political Science", 45],
  ["Professional Development", 330],
  ["Psychiatry", 1085],
  ["Psychology", 46],
  ["Radiology", 1371],
  ["Religion", 47],
  ["Religious Studies", 339],
  ["Russian Studies", 136],
  ["Scandinavian", 1022],
  ["Science", 48],
  ["Slavic Languages", 1322],
]);
